import React, { useEffect, useState } from 'react';
import WrapperComponent from '../../commonComponents/WrapperComponent';
import './SequenceStyles.css';
import { useNavigate } from 'react-router-dom';
import { url } from '../../../util/config';
import SequenceView from './SequenceView';

const CreateCard = () => {
  const navigate = useNavigate();
  return (
    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className="card create-card h-100 d-flex flex-column align-items-center justify-content-center text-center">
        <div className="create-icon mb-2 d-flex align-items-center justify-content-center" style={{ height: '48px' }}>
          <i className="bi bi-plus-lg text-white fs-1" onClick={() => navigate('/createsequence')}></i>
        </div>
        <div className="create-label" onClick={() => navigate('/createsequence')}>Create New Sequence</div>
      </div>
    </div>
  );
};

const SequenceCard = ({ sequence, onEdit, onView }) => {
  return (
    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className="card sequence-card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="card-title">{sequence.title}</h5>
            <span className={`badge ${
              sequence.status === 'published' ? 'bg-success' :
              sequence.status === 'draft' ? 'bg-primary' : 'bg-secondary'
            }`}>
              {sequence.status || '—'}
            </span>
          </div>

         <p className='card-text text-muted mb-1'>
          <i className='bi bi-calendar-event me-2'></i>
          {new Date(sequence.createdAt).toLocaleDateString()} at {new Date(sequence.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </p>

          <p className="mb-1">{sequence.stepsCount} step{sequence.stepsCount !== 1 ? 's' : ''}</p>
          

          <div className="stats">
              <div>Enrolled: {sequence.enrolled}</div>
              <div>Completed: {sequence.completed}</div>
              <div>Goal: {sequence.goal}</div>
          </div>

        </div>

        <div className="card-footer text-end">
          <button className="btn btn-outline-primary btn-sm me-2" onClick={() => onEdit(sequence)}>Edit</button>
          <button className="btn btn-outline-secondary btn-sm" onClick={() => onView(sequence._id)}>View</button>
        </div>
      </div>
    </div>
  );
};

const SequenceDashboard = () => {
  const navigate = useNavigate();
  const [sequences, setSequences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [viewSequence, setViewSequence] = useState(null);


  // fetch sequences from API
  useEffect(() => {
    let mounted = true;
    const fetchSequences = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${url}/sequence`, {
          headers: { Authorization: 'Bearer ' + token }
        });
        if (!res.ok) throw new Error(`Fetch failed (${res.status})`);
        const data = await res.json();
        // data may be array or wrapped object depending on backend
        const list = Array.isArray(data) ? data : (data.data || []);
        if (!mounted) return;

        // Map each sequence according to your sample JSON shape
        const mapped = list.map(s => ({
          _id: s._id || s.id,
          title: s.name || 'Untitled',
          contactid: s.contactid || s.basedOn?.contactId || null,
          groupName: s.group_name || s.basedOn?.groupName || null,
          header: s.header || s.basedOn?.header || null,
          sendFrom: s.sendFrom || null,
          triggerCondition: s.triggerCondition || null,
          startConditions: s.startConditions || [],
          stopSuccessConditions: s.stopSuccessConditions || [],
          stopFailureConditions: s.stopFailureConditions || [],
          defaultDeliveryPreference: s.defaultDeliveryPreference || s.deliveryPref || {},
          stepsCount: Array.isArray(s.steps) ? s.steps.length : (s.steps_count || 0),
          steps: s.steps || [],
          statusCode: s.statusCode ?? s.meta?.statusCode,
          status: (s.status || s.meta?.status || (s.statusCode === 1 ? 'draft' : s.statusCode === 2 ? 'published' : '—')),
          raw: s,
          createdAt: s.createdAt,
          enrolled: s.stats?.enrolled || 0,
          completed: s.stats?.completed || 0,
          goal: s.stats?.goal || 0,
        }));

        setSequences(mapped);
      } catch (err) {
        if (!mounted) return;
        setError(err.message || 'Failed to load sequences');
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchSequences();
    return () => { mounted = false; };
  }, []);

  const handleEdit = (seq) => {
    // navigate to create/edit page; pass sequence id so CreateSequence can load JSON and pre-fill
    //navigate(`/createsequence/${id}`);
    navigate('/createsequence', { state: { initialSequence: seq.raw || seq } });
  };

  const handleView = (id) => {
    const seq = sequences.find(s => s._id === id) || sequences.find(s => s.id === id) || null;
    setViewSequence(seq ? seq.raw || seq : null);
  };

  return (
    <WrapperComponent>
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4 px-3">
          <h4>Sequences</h4>
          <div>
            <button className="btn btn-primary" onClick={() => navigate('/createsequence')}>Create Sequence</button>
          </div>
        </div>

        <div className="row px-3">
          <CreateCard />
          {loading && <div className="col-12 px-3">Loading...</div>}
          {error && <div className="col-12 text-danger px-3">Error: {error}</div>}
          {!loading && sequences.length === 0 && <div className="col-12 px-3 text-muted">No sequences found</div>}
          {sequences.map(seq => (
            <SequenceCard key={seq._id} sequence={seq} onEdit={handleEdit} onView={handleView} />
          ))}
        </div>
      </div>
      {viewSequence && (
        <SequenceView sequence={viewSequence} onClose={() => setViewSequence(null)} />
      )}
    </WrapperComponent>
  );
};

export default SequenceDashboard;